import {useEffect, useState} from "react";
import InnerHTML from 'dangerously-set-html-content';
import ajaxService from "../../../utils/ajaxServices";
import config from "../../../config/index";

let fetched = false;

export default function Headerfragment(){
    const env = config.env;
    const drupal = config.envConfigs[env].drupalApi.url;
    const [menuFragment, setMenuFragment] = useState("<div />");
    useEffect(()=>{
        const getNavigation = async () => {
            fetched = true;
            let fragment = await ajaxService.httpGet(
                "drupalBaseUrl",
                "",
                "api",
                "headerFragment","","text");
            if(fragment){
                const abslutePath = fragment.replace(/src="\/theme/g,`src="${drupal}/theme`);
                setMenuFragment(abslutePath)
            }
        }
        if (!fetched) getNavigation();
    },[])
    return <InnerHTML id="headerFragment" html={menuFragment} />
}